import React, { Component } from 'react'
import { connect } from 'react-redux'
import Particles from 'react-particles-js'
import { initParticle, setColour, setParticleNumber } from '../../actions/ParticlesActions'
import './CopperCoastParticles.css'

@connect((state) => ({
    defaultConfig: state.particlesReducer.default,
    configs: state.particlesReducer
}), { initParticle, setColour, setParticleNumber })
class CopperCoastParticles extends Component {

  handleMouseMove = (e) => {
    const { showStars, particlesId, starsId } = this.props
    var stars1 = showStars && document.getElementById(starsId)
    var main = document.getElementById(particlesId)
    var mousePos = {
      x: e.screenX,
      y: e.screenY
    }

    var new_x = mousePos.x * -1 / 8;
    var new_y = mousePos.y * -1 / 8;

    if (stars1) {
      stars1.style.left = new_x / 2 + "px";
      stars1.style.top = new_y / 2 + "px";
    }

    if (main) {
      main.style.left = new_x / 3 + "px";
      main.style.top = new_y / 3 + "px";
    }
  }

  componentDidMount() {
    const { defaultConfig, colour, initParticle, particlesId, setColour, setParticleNumber, /*mouseMoveContainerId*/ } = this.props
    initParticle(particlesId, defaultConfig)
    if (colour) setColour(particlesId, colour)
    // if (window.innerWidth > 768) {
    //   if (mouseMoveContainerId) {
    //     document.getElementById(mouseMoveContainerId).addEventListener('mousemove', this.handleMouseMove, false)
    //   } else {
    //     document.addEventListener('mousemove', this.handleMouseMove, false)
    //   }
    // }
    if (window.innerWidth < 768) setParticleNumber(particlesId, 20)
  }

  componentWillUnmount() {
    //const { mouseMoveContainerId } = this.props
    // if (window.innerWidth > 768) {
    //   if (mouseMoveContainerId) {
    //     document.getElementById(mouseMoveContainerId).removeEventListener('mousemove', this.handleMouseMove, false)
    //   } else {
    //     document.removeEventListener('mousemove', this.handleMouseMove, false)
    //   }
    // }
  }

  render() {
    const { configs, showStars, particlesId, starsId, className } = this.props
    const starHeight = this.props.starHeight || '100%'
    return (
      <div id={particlesId} className={className ? className : 'CopperCoastParticles'}>
        { showStars && starsId &&
          [
            <div key={0} id={starsId} className="CopperCoastParticles-stars" style={{height: starHeight }}></div>,
            <div key={1} className="CopperCoastParticles-stars" style={{height: starHeight}}></div>
          ]
        }
        { configs && configs[particlesId] && <Particles params={configs[particlesId]}/> }
      </div>
    )
  }
}

export default CopperCoastParticles;



// WEBPACK FOOTER //
// ./src/components/CopperCoastParticles/index.js